import { Box } from '@mui/material';
import { LpPuckPreview } from '@sysmobil/synoro-packages';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import cfac22 from 'js/library/utils/cfac22';

export default function LandingPagePuck({ campaignId }) {
  const { userInfo } = useCurrentUserInfo();

  return (
    <Box sx={{ minHeight: '86vh' }}>
      <LpPuckPreview campaignId={campaignId} ambient={cfac22('ambient')} userInfo={userInfo} />
    </Box>
  );
}
